import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("同步")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, reactive, computed } from 'vue'
import tbMix, {cpyCfig} from '@/global_mixin/tableMixin'
import { formatTime, formatNumber } from '@/utils/index'
import eptBtn from '@/components/ExportButton.vue'
import { ElMessage, ElMessageBox } from 'element-plus';
import PaymentModuleUtils, { makeInvoiceTypeOption, serviceTypeOption } from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {currencyOption} = PaymentModuleUtils
let { 
  'POST/translator/query': fetchList,
  // 添加
  'POST/translator': translatorAddApi,
  // 修改
  'PATCH/translator': translatorPatchApi,
  // 删除
  'DELETE/translator': translatorDelApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 译员_导入
  'POST/translator/import': importTranslatorApi,
  // 译员_导出
  'POST/translator/export': exportTranslatorApi,
  // 译员_同步
  'GET/translator/sync': syncApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: [],
    upKey: 'date',
    props: {
      type: 'monthrange',
      'value-format': 'YYYY-MM-DD'
    }
  },
  {
    label: "译员ID",
    value: '',
    upKey: 'resourceId',
    props: { clearable : true }
  }
])
// 搜索
const searchHandle = (params: any) => {
  fetchData({
    query: {
      ...params,
      createTimeRange: {
        from: params.date ? params.date[0] : '',
        to: params.date ? params.date[1] : '',
      }
    }
  })
}
// 添加
const addFg = ref(false)
const addConfig = ref([
  {
    label: "译员ID",
    value: '',
    upKey: 'resourceId',
    props: { },
    rule: [
      { required: true, message: '译员ID不能为空', trigger: 'change' },
    ],
  },
  {
    type: 'SELECT',
    label: '译员类型',
    value: null,
    upKey: 'resourceType',
    options: [
      {label: 'freelancer', id: 'freelancer'},
      {label: 'abroad', id: 'abroad'},
      {label: 'china', id: 'china'},
    ],
    props: { clearable: true, placeholder: '请选择译员类型',},
    seleProps: { label: 'label', valueName: 'id'},
  },
  {
    label: "译员名字",
    value: null,
    upKey: 'fullName',
    props: { }
  },
  {
    type: 'SELECT',
    label: '公司',
    value: null,
    upKey: 'company',
    options: [
      {label: '深圳市昆仲科技有限公司', id: '深圳市昆仲科技有限公司'},
      {label: '深圳市昆仲科技有限公司（云账户）', id: '深圳市昆仲科技有限公司（云账户）'},
      {label: 'CCJK CO LIMITED', id: 'CCJK CO LIMITED'},
    ],
    props: { clearable: true, placeholder: '请选择公司',},
    seleProps: { label: 'label', valueName: 'id'},
  },
  {
    type: 'SELECT',
    label: '服务方类型',
    value: null,
    upKey: 'serviceType',
    options: serviceTypeOption('option'),
    props: { clearable: true, placeholder: '请选择服务方类型',},
    seleProps: { label: 'label', valueName: 'id'},
  },
  {
    type: 'SELECT',
    label: '开票类型',
    value: null,    
    upKey: 'invoiceType',
    options: makeInvoiceTypeOption('option'),
    props: { clearable: true, placeholder: '请选择服务方类型',},
    seleProps: { label: 'label', valueName: 'id'},
  },
  {
    type: 'SELECT',
    label: '适用增值税税率',
    value: '',    
    upKey: 'taxRate',
    options: [   
      {label: '0', id: '0'},
      {label: '1', id: '1'},
      {label: '3', id: '3'},
      {label: '6', id: '6'},
    ],
    props: { clearable: true, placeholder: '请选择税率'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '支付币种',
    value: null,
    upKey: 'payCurrency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
])
const addHandle = async() => { 
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    await translatorAddApi(params)
    ElMessage.success('添加成功')
    addFg.value = false
    fetchData(MI_params)
  })

}

// 修改
const modifyFg = ref(false)
const modifyHandle = (row: any) => {
  MI_modifyForm(row, addConfig, modifyFg, async(params: any) => {
    await translatorPatchApi({
      ...params,
      id: row.id
    })
    ElMessage.success('修改成功')
    modifyFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = async (row: {id: string}) => {
  try {
    await ElMessageBox.confirm(
      '是否确认删除？',
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    )
    MI_identify.value = true
    await translatorDelApi({ id: row.id }, { contentType: 'formData'})
    MI_identify.value = false
    ElMessage.success('删除成功')
    fetchData(MI_params)
  } catch (error) {
    MI_identify.value = false
    
  }
}

// 导出参数
let exportParams = computed(() => {

  return MI_params.query ? MI_params.query : {}
})

// 同步译员
const syncHandle = () => {
  MI_identify.value = true
  syncApi().then(() => {
    MI_identify.value = false
    ElMessage.success('同步成功')
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "译员维护" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_TheUpBtn, {
        class: "ml-10",
        showBtn: true,
        upText: '导入译员',
        upFetch: _unref(importTranslatorApi),
        upParams: {},
        onUpSuccess: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
      }, null, 8, ["upFetch"]),
      _createVNode(_component_el_tooltip, {
        effect: "dark",
        content: "请先搜索，后导出",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createVNode(eptBtn, {
            exportFn: _unref(exportTranslatorApi),
            exportText: '导出译员',
            exportParam: _unref(exportParams)
          }, null, 8, ["exportFn", "exportParam"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (syncHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id"
        }),
        _createVNode(_component_el_table_column, {
          label: "译员ID",
          prop: "resourceId"
        }),
        _createVNode(_component_el_table_column, {
          label: "译员类型",
          prop: "resourceType"
        }),
        _createVNode(_component_el_table_column, {
          label: "译员名字",
          prop: "fullName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "company",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "服务方类型",
          prop: "serviceType",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", null, _toDisplayString(_unref(serviceTypeOption)()[row.serviceType]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "开票类型",
          prop: "invoiceType"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", null, _toDisplayString(_unref(makeInvoiceTypeOption)()[row.invoiceType]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "适用增值税税率",
          prop: "taxRate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "译员币种",
          prop: "resourceCurrency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "支付币种",
          prop: "payCurrency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createdDate",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "创建人",
          prop: "createdName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "是否内部译员",
          prop: "isCcjkUser",
          "show-overflow-tooltip": "",
          formatter: (row) => row.isCcjkUser === true ? '是' : '否'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (modifyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-5",
      "page-sizes": [ 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "添加",
      draggable: "",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改",
      draggable: "",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})